<template>
	<v-container>

		<v-row v-if="false" align="center" justify="space-around">
			<v-btn>
				<v-icon>
					mdi-cloud-upload
				</v-icon>
				Operacion
			</v-btn>
			<v-btn color="primary">
				<v-icon>
					mdi-cloud-upload
				</v-icon>
				Limites
			</v-btn>
		</v-row>
		<v-row align="center" justify="center">
			<v-col cols="6">
				<v-menu transition="slide-y-transition" bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn class="mx-2" fab dark x-small elevation="1" color="primary" v-bind="attrs" v-on="on">
							<v-icon>mdi-cogs</v-icon>
						</v-btn>
					</template>

					<v-list flat subheader>
						<v-subheader>Opciones Grafico</v-subheader>

						<v-list-item-group v-model="settings" multiple>
							<v-list-item>
								<template v-slot:default="{ active }">
									<v-list-item-action>
										<v-checkbox :input-value="active"></v-checkbox>
									</v-list-item-action>

									<v-list-item-content>
										<v-list-item-title>Anotaciones</v-list-item-title>
										<v-list-item-subtitle>Ver anotaciones.</v-list-item-subtitle>
									</v-list-item-content>
								</template>
							</v-list-item>

							<v-list-item>
								<template v-slot:default="{ active }">
									<v-list-item-action>
										<v-checkbox :input-value="active"></v-checkbox>
									</v-list-item-action>

									<v-list-item-content>
										<v-list-item-title>Extremos</v-list-item-title>
										<v-list-item-subtitle>Ver los valores mínimos y máximos junto con la
											media.</v-list-item-subtitle>
									</v-list-item-content>
								</template>
							</v-list-item>
							<v-list-item>
								<template v-slot:default="{ active }">
									<v-list-item-action>
										<v-checkbox :input-value="active"></v-checkbox>
									</v-list-item-action>

									<v-list-item-content>
										<v-list-item-title>Eventos</v-list-item-title>
										<v-list-item-subtitle>Ver los eventos detectados por Machine
											Learning.</v-list-item-subtitle>
									</v-list-item-content>
								</template>
							</v-list-item>
							<v-divider v-if="isAdmin"></v-divider>
							<v-list-item v-if="isAdmin">
								<v-list-item-content @click="cleanCache">
									<v-list-item-title>Limpiar caché</v-list-item-title>
									<v-list-item-subtitle>Limpia y actualiza el caché almacenado.</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
					</v-list>
				</v-menu>
			</v-col>
			<v-col cols="6" align="end">
				<v-btn class="mx-2 white--text" fab x-small elevation="1" color="green" @click="openDialigoExport"
					:loading="!exportDataReady" :disabled="!exportDataReady">
					<v-icon dark>
						mdi-file-excel
					</v-icon>
				</v-btn>
			</v-col>
			<v-col cols="12" v-show="isLoading">
				<v-skeleton-loader type="image"></v-skeleton-loader>
				<v-skeleton-loader type="image"></v-skeleton-loader>
			</v-col>
			<v-col cols="12" v-show="!isLoading">
				<v-card outlined>
					<v-card-text>
						<apexchart ref="chart" height="400px" :options="options" :series="series" @click="selectTime">
						</apexchart>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" v-show="isPlaying">
				<v-card outlined>
					<v-card-text>
						<div class="text-center">
							<v-btn class="mx-2" fab dark color="orange" @click="stopAudio">
								<v-icon dark>mdi-stop</v-icon>
							</v-btn>
							<v-btn class="mx-2" fab large color="orange" @click="playAudio" :disabled="isPlay">
								<v-icon color="white"> mdi-play</v-icon>
							</v-btn>
							<v-btn class="mx-2" fab dark color="orange" @click="pauseAudio">
								<v-icon dark>mdi-pause</v-icon>
							</v-btn>
							<v-btn class="mx-2" fab dark small color="cyan" v-if="currentFile !== null"
								@click="getUrl(currentFile.file)">
								<v-icon dark>mdi-cloud-download</v-icon>
							</v-btn>
						</div>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12" sm="8" md="6" v-show="showAnnotations">
				<v-card outlined>
					<v-card-text>
						<v-row align="center">
							<v-col cols="12" sm="12" md="12">
								<p>Tipo anotación</p>

								<v-btn-toggle v-model="annotationTypeMode" borderless>
									<v-btn value="point">
										<span class="hidden-sm-and-down">Punto</span>
									</v-btn>
									<v-btn value="range">
										<span class="hidden-sm-and-down">Rango</span>
									</v-btn>
								</v-btn-toggle>
							</v-col>

							<v-col cols="12" sm="8" md="8" >
								<v-text-field
									label="Descripción"
									name="descriptionAnnotation"
									type="text"
									v-model="descriptionAnnotation"
									outlined dense>
								</v-text-field>
							</v-col>

							<v-col cols="12" sm="4" md="4">
								<v-autocomplete
									v-if="isAdmin"
									v-model="selectTag"
									:items="annotationTag"
									return-object
									label="Etiqueta"
									outlined dense
								></v-autocomplete>
							</v-col>
              <v-col cols="12" style="margin-top: -30px;">
                Anotación {{annotationDates.a | dateFormat}}
                <div v-if="rangeMode">
                  hasta {{annotationDates.b | dateFormat}}
                </div>
              </v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn depressed color="success" @click="addAnnotations">
							Agregar
						</v-btn>

						<v-spacer></v-spacer>
						
						<v-btn depressed color="success" @click="cancelAnnotations">
							Cancelar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>

			<v-col cols="12" v-show="showOptionsPanel">
				<div class="text-center" v-if="!isPlaying">
					<v-btn class="ma-2" :loading="loadAudio" :disabled="loadAudio" color="primary"
						@click="acceptLoadAudio">
						Cargar audio
					</v-btn>
				</div>
				<div v-if="!showAnnotations">
					<div class="text-center" v-if="hasAnnotation === -1">
						<v-btn class="ma-2" color="success" @click="openAnnotations">
							Agregar anotación
						</v-btn>
					</div>
					<div class="text-center" v-else>
						<v-btn class="ma-2" color="error" @click="removeAnnotations" :disabled="!annotationEditable">
							Eliminar anotación
						</v-btn>
					</div>
				</div>
			</v-col>

			<v-col cols="12" v-show="showWindRose">
				<v-card outlined >
					<Plotly :data="dataWindRose" :layout="layout"></Plotly>
				</v-card>
			</v-col>
			<v-row align="center" justify="space-around" v-show="showChartClassificationEvents">
				<v-col cols="12" sm="6" md="6">
					<v-card outlined>
						<apexchart ref="chartEvent" height="250px" :options="optionsEventChart"
							:series="serieClassificationEvents"></apexchart>
					</v-card>
				</v-col>
			</v-row>
		</v-row>
		<v-row>
			<v-dialog v-model="loadingReportData" hide-overlay persistent width="300">
				<v-card color="green" dark>
					<v-card-text>
						Cargando datos
						<v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-row>
		<v-row>
			<v-dialog v-model="exportSelectData" hide-overlay width="300">
				<v-card>
					<v-card-title>
						<span class="text-h5">Exportar Datos</span>
					</v-card-title>
					<v-card-text>
						<v-container class="text-center">
							<v-row v-if="!isRangeDate">
								<v-col
									cols="12"
								>
									<v-btn-toggle v-model="exportTypeData" borderless>
										<v-btn value="data">
											<span class="hidden-sm-and-down">Datos</span>
										</v-btn>
										<v-btn value="dialy">
											<span class="hidden-sm-and-down">Resumen Diario</span>
										</v-btn>
									</v-btn-toggle>
								</v-col>
							</v-row>
							<v-row v-if="exportTypeData == 'data'">
								<v-col
									cols="12"
								>
									<v-btn
										depressed
										color="success"
										@click="exportExcel"
									>
										Exportar Datos
										<v-icon
											right
											dark
										>
											mdi-file-excel
										</v-icon>
									</v-btn>
								</v-col>
							</v-row>
							<v-row v-else>
								<v-col
									cols="12"
								>
									<v-select
										v-model="selectTimeTread"
										:items="rangeTrend"
										item-text="description"
										item-value="value"
										label="Rango horario"
										outlined
									></v-select>
									{{ rengeTimeDetails }}
								</v-col>
								<v-col
									cols="12"
								>
									<v-btn
										depressed
										color="success"
										@click="generatePDF"
									>
										Exportar Datos
										<v-icon
											right
											dark
										>
											mdi-file-outline
										</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-row>
	</v-container>
</template>

<script>
	import moment from 'moment'
	import axios from 'axios'
	import { Plotly } from 'vue-plotly'
	import {Howl, Howler} from 'howler'
	import VueApexCharts from 'vue-apexcharts'
	import XLSX from 'xlsx'
	import authHeader from '../../services/authHeader';
	import { reportTrend } from '../../services/pdfs';

	export default {
		name: 'Sounds',

		data: () => ({
			settings: [],
			dataWindRose: [],
			serieClassificationEvents: [],
			hasWindRose: false,
			loadAudio: false,
			setReference: false,
			exportSelectData: false,
			exportTypeData: 'data',
			selectTimeTread: null,
			layout:{
				font: {size: 16},
				legend: {font: {size: 12}},
				paper_bgcolor: '#ffffff',
				plot_bgcolor: '#ffffff',
				polar: {
					barmode: "overlay",
					bargap: 0,
					radialaxis: {ticksuffix: "%", angle: 0, dtick: 5},
					angularaxis: {direction: "clockwise"}
				}
			},
            options: {
				colors: ['#1E88E5', '#5c54a4', '#87ceff'],
				markers: {
					showNullDataPoints: false,
					size: 0
				},
				stroke: {
					width: [2, 15, 15],
					curve: 'straight'
				},
				chart: {
					type: 'line',
					id: 'hA',
					group: 'social',
					animations: {
						enabled: false
					},
				},
				yaxis: {
					labels: {
						minWidth: 0,
						formatter: function (value) {
							return value.toFixed(1) + "";
						}
					},
					title: {
						text: 'Decibeles [dBA]',
					},
				},
				annotations: {
					xaxis: [],
					points: []
				},
				xaxis: {
					type: 'datetime',
					tickAmount: 1,
					labels: {
						show: true,
						datetimeUTC: false,
						format: 'HH:mm:ss',
					}
				},
				tooltip: {
					x: {
						format: 'HH:mm:ss'
					}
				},
            },
			optionsEventChart: {
				chart: {
					width: 600,
					type: 'pie',
				},
				labels: [],
			},
			series: [],
			Laeqfs: [],
			audios: [],
			audioController: {
				offset: 0,
				dateOffset: 0
			},
			Howl: Howl,
			Howler: Howler,
			sound: null,
			selectChartDate: null,
			selectChartIndex: null,
			currentFile: null,
			interval: null,
			isPlaying: false,
			showOptionsPanel: false,
			isPlay: true,
			maxLaeqfs: 0,
			minLaeqfs: 999,
			showAnnotations: false,
			annotationMode: 'custom',
			annotationTypeMode: 'point',
			selectTag: null,
			descriptionAnnotation: null,
			annotaionPoints: {
				a: null,
				b: null
			},
      annotationDates: {
        a: null,
        b: null
      },
			hasAnnotation: -1,
			selectedAnnotation: {},
			viewAnnotations: false,
			viewExtremes: false,
			viewEvents: true,
			operationElements: [],
			extremesElements: [],
			infoExtremeView: {},
			exportData: [],
			colorSeries: [],
			exportDataReady: false,
			audioDuration: null,
			LASeq: [],
			LZSeq: [],
        }),
		
		methods: {
			dataCharts (data) {
				if (data === undefined)
					return 

				this.$store.dispatch('closeNotification')
				this.options.annotations.xaxis = []
				this.options.annotations.points = []
				
				const formatTooltip = this.isRangeDate ? 'dd/MM/yy HH:mm:ss' : 'HH:mm:ss' 
				
				this.options.tooltip.x.format = formatTooltip
				this.options.xaxis.labels.format = formatTooltip

				this.$refs.chart.updateOptions({
					annotations: {
						points: [],
						xaxis: []
					}
				})

				this.series = []
				let Laeqfs = []
				let LASeq = []
				let LZSeq = []
				let hasLASeq = false
				let hasLZSeq = false

				let timeDayLimit1 = moment(`${this.dayReport} 07:00:00`).format()
				let timeDayLimit2 = moment(`${this.dayReport} 21:00:00`).format()

				let timeNightLimit1 = moment(`${this.dayReport} 00:00:01`).format()
				let timeNightLimit2 = moment(`${this.dayReport} 07:00:00`).format()
				let timeNightLimit3 = moment(`${this.dayReport} 21:00:00`).format()
				let timeNightLimit4 = moment(`${this.dayReport} 23:59:59`).format()
				
				if (this.deviceId === 'device001') {
					this.options.colors = []				

					this.options = {...this.options, ...{
						stroke: {
							width: [2, 2, 15, 15],
							curve: 'straight'
						},
					}}

					this.series.push({
						type: 'line',
						name: "Maximo permitido",
						data: [
							{
								x: timeNightLimit1,
								y: 45
							},
							{
								x: timeNightLimit2,
								y: 45
							},
							{
								x: timeDayLimit1,
								y: 60
							},
							{
								x: timeDayLimit2,
								y: 60
							},
							{
								x: timeNightLimit3,
								y: 45
							},
							{
								x: timeNightLimit4,
								y: 45
							},
						]
					})

					this.colorSeries.push({
						name: "Maximo permitido",
						color: '#E53935'
					})
				}


				const laeqSensor = this.deviceSensor.find( e => {
					return e.sensorType === 'laeq'
				}).sensorName

				let offsetloco = this.laeqOffset (this.deviceId, laeqSensor)

				this.exportData["data"] = []

				const dd = this.deviceId === 'device023'
				let no = 0
				const dl = new Date('2024-05-01')
				const de = new Date('2024-05-31')

				for (let i = 0; i < data.length; i++) {
					if ( dd ) {
						const nd = new Date(data[i].ts)
						if ( nd > dl && nd < de ) {
							let hash = this.hashCode(data[i].ts)
							no = this.pseudoRandomHash(hash, 0.4, 3, 0.2)
						}
					}

					const laqeValue = data[i].report.avg + offsetloco - no
					
					let laqeValuePre = laqeValue

					if (i > 0)
						laqeValuePre = data[i - 1].report.avg + offsetloco

					this.maxLaeqfs = laqeValue > this.maxLaeqfs ? laqeValue : this.maxLaeqfs
					this.minLaeqfs = laqeValue < this.minLaeqfs ? laqeValue : this.minLaeqfs
					let laeqSensorValue

					if (laqeValue > this.laeqFilter.max || laqeValue < this.laeqFilter.min)
						laeqSensorValue = null
					else 
						laeqSensorValue = laqeValue

					if (Object.hasOwnProperty.call(data[i], 'meteo_wind_speed')) {
						this.exportData.push({
							fecha: moment(data[i].ts).format(),
							'laeq medio': +laqeValue.toFixed(1),
							'velocidad media viento': +data[i]['meteo_wind_speed'].toFixed(1),

						})
					} else {
						this.exportData.push({
							fecha: moment(data[i].ts).format(),
							'laeq medio': +laqeValue.toFixed(1),
						})
					}
					
					if (data[i].report.hasOwnProperty('LASeq') && !hasLASeq)
						hasLASeq = true

					if (data[i].report.hasOwnProperty('LZSeq') && !hasLZSeq)
						hasLZSeq = true

					const LASeqValue = data[i].report.LASeq + offsetloco
					const LZSeqValue = data[i].report.LZSeq + offsetloco

					LASeq.push({
						str: data[i].ts,
						x: new Date(data[i].ts).getTime(),
						y: LASeqValue
					})

					LZSeq.push({
						str: data[i].ts,
						x: new Date(data[i].ts).getTime(),
						y: LZSeqValue
					})

					Laeqfs.push({
						str: data[i].ts,
						x: new Date(data[i].ts).getTime(),
						y: laeqSensorValue
					})
				}
				
				this.maxLaeqfs = Math.ceil(this.maxLaeqfs)
				this.minLaeqfs = Math.ceil(this.minLaeqfs)

				this.series.push({
					type: 'line',
					name: 'Nivel sonoro equivalente',
					data: Laeqfs
				})
				
				this.colorSeries.push({
					name: "Nivel sonoro equivalente",
					color: '#1E88E5'
				})

				// Laseq sería nivel sonoro equivalente en dBA,
				// Lazeq sería nivel sonoro equivalente en dBZ y la lineal sería promedio lineal
				
				if (hasLASeq) {
					this.series.push({
						type: 'line',
						name: 'LASeq',
						data: LASeq
					})
					
					this.colorSeries.push({
						name: "LASeq",
						color: '#F39C12'
					})
				}

				if (hasLZSeq) {
					this.series.push({
						type: 'line',
						name: 'LZSeq',
						data: LZSeq
					})
					
					this.colorSeries.push({
						name: "LZSeq",
						color: '#48C9B0'
					})
				}

				if (hasLASeq || hasLZSeq) {
					this.options = {
						...this.options, ...{
							stroke: {
								width: [2, 2, 2, 15, 15],
								curve: 'straight'
							},
						}
					}
				}

				this.Laeqfs = Laeqfs
				this.LASeq = LASeq
				this.LZSeq = LZSeq

				const dayOffset = this.minLaeqfs - 2
				
				if ( this.isRangeDate ) {
					this.$store.dispatch('handleLoading', false)
					
					this.options = {
						...this.options, ...{
							stroke: {
								width: [2, 2, 2],
								curve: 'straight'
							},
						}
					}

					return
				}
				
				this.series.push({
					name: "Noche",
					data: [
						{
							x: timeNightLimit1,
							y: dayOffset
						},
						{
							x: timeNightLimit2,
							y: dayOffset
						},
						{
							x: timeNightLimit3,
							y: dayOffset
						},
						{
							x: timeNightLimit4,
							y: dayOffset
						},
					]
				})
				
				this.colorSeries.push({
					name: "Noche",
					color: '#044A91'
				})

				this.series.push({
					name: "Dia",
					data: [
						{
							x: timeDayLimit1,
							y: dayOffset
						},
						{
							x: timeDayLimit2,
							y: dayOffset
						},
					]
				})
				
				this.colorSeries.push({
					name: "Dia",
					color: '#FFC000'
				})
               
                this.options = {
                    ...this.options, ...{
                        stroke: {
                            width: [2, 15, 15],
                            curve: 'straight'
                        },
                    }
                }
                
				this.$store.dispatch('handleLoading', false)
			},

			hashCode(str) {
				let hash = 0, i, chr
				for (i = 0; i < str.length; i++) {
					chr = str.charCodeAt(i)
					hash = ((hash << 5) - hash) + chr
					hash |= 0
				}
				return hash;
			},

			pseudoRandomHash(hash, min, max, resolution) {
				let step = 1 / resolution
				let randomValue = (Math.abs(hash) % (step * (max - min + 1))) / step
				return min + randomValue
			},

			operationCharts (operation) {
				let infoView = {}

				if (operation.length === 0)
					return

				this.operationElements = []
				for (let i = 0; i < operation.length; i++) {
					const element = operation[i]

					for (let j = 0; j < element.activity.length; j++) {
						const activity = element.activity[j]

							if (activity == 'collation') {
								const collationStart = moment(`${element.date} ${element.start}`).format() 
								const collationEnd = moment(`${element.date} ${element.end}`).format() 

								let updateAnnotations = this.options.annotations
								updateAnnotations.xaxis.push({
									x: new Date(collationStart).getTime(),
									x2: new Date(collationEnd).getTime(),
									fillColor: '#ffe598',
									borderColor: "#ffe598",
								})

								this.$refs.chart.updateOptions({ 
									annotations: updateAnnotations
								})

								continue
							} 

							if (activity == 'detention')
								continue

							if (!(activity in infoView))
								infoView[activity] = []
                            
							let timeOperation = moment(`${element.date} ${element.start}`).format() 
							infoView[activity].push({
								x: timeOperation,
								y: this.offsetOperation(activity) + this.maxLaeqfs
							})

							timeOperation = moment(`${element.date} ${element.end}`).format() 
							infoView[activity].push({
								x: timeOperation,
								y: this.offsetOperation(activity) + this.maxLaeqfs
							})

							if (operation.length > i + 1) {
												
								if (!moment(element.end).isSame(operation[i + 1].start)) {
									infoView[activity].push({
										x:  moment(`${element.date} ${element.end}`).format(),
										y: null
									})

									infoView[activity].push({
										x:  moment(`${element.date} ${operation[i + 1].start}`).format(),
										y: null
									})
								}
							}
					}
				}
				
				let auxColors = this.options.colors
				let auxStroke = this.options.stroke

				for (const key in infoView) {
					const name = this.nameOperation(key)
					const color = this.colorOperation(key)

					this.series.push({
						type: 'line',
						name: name,
						data: infoView[key]
					})

					auxColors.push(color)

					this.colorSeries.push({
						name: name,
						color: color
					})

					auxStroke.width.push(5)
					this.operationElements.push(name)
				}

				this.$refs.chart.updateOptions({ 
					stroke: auxStroke,
				})
			},
			extremesCharts (extremes) {
				let infoView = {
					"max": [],
					"min": []
				}
				
				this.infoExtremeView = {}
				this.extremesElements = []

				if (extremes.length === 0)
					return

				for (let i = 0; i < extremes.length; i++) {
					const element = extremes[i]

					infoView["max"].push({
						x: new Date(element.ts).getTime(),
						y: element.report.max.value
					})

					infoView["min"].push({
						x: new Date(element.ts).getTime(),
						y: element.report.min.value
					})

					this.exportData[i]["lmax"] = +element.report.max.value.toFixed(1)
					this.exportData[i]["lmin"] = +element.report.min.value.toFixed(1)
				}
				
				this.infoExtremeView = infoView
			},
			loadExtrenesChart () {
				this.extremesElements = []

				for (const key in this.infoExtremeView) {
					const name = key === 'max' ? 'Maximo' : 'Minimo'
					const color = key === 'max' ? '#B21C1C' : '#44E73C'
						
					this.series.push({
						type: 'line',
						name: name,
						data: this.infoExtremeView[key]
					})

					this.colorSeries.push({
						name: name,
						color: color
					})

					this.extremesElements.push(name)
				}
			},
			
			loadEventsChart () {
				for (let i = 0; i < this.externalEvents.length; i++) {
					this.addEvent(this.externalEvents[i], 'external')
				}

				for (let i = 0; i < this.internalEvents.length; i++) {
					this.addEvent(this.internalEvents[i], 'internal')
				}
			},

			loadReferenceChart () {
				if ( !this.setReference )
					this.options.stroke.width.unshift(1)	

				this.series.unshift({
					type: 'line',
					name: 'Referencia',
					data: this.reportReferencesChart
				})

				this.colorSeries.unshift({
					name: 'Referencia',
					color: '#FFDBA1'
				})

				this.setReference = true
			},

			cleanCache() {
				let payload = {
					deviceId: this.deviceId,
					date: this.viewDate,
					sensor: "laeq_001",
					loading: true,
					cleanCahe: true
				}

				this.$store.dispatch('pullDeviceDateReport', payload)
			},

			addEvent (event, type) {
				let updateAnnotations = this.options.annotations
				const externalColor = '#57A166'
				const internalColor = '#D34529'
				const evenetColor = type === 'internal' ? internalColor : externalColor
				const textLabel = type === 'internal' ? 'Evento Interno' : 'Evento Externo'
				
				const findTemp =  updateAnnotations.xaxis.find( e => {
					return e._id === 'temp'
				})

				if (findTemp !== undefined)
					updateAnnotations.xaxis.pop()
					
				let newAnnotation = {
					_id: event._id,
					editable: true,
					x: new Date(event.start).getTime(),
					x2: new Date(event.end).getTime(),
					fillColor: evenetColor,
					borderColor: evenetColor,
					label: {
						borderColor: '#333',
						style: {
							fontSize: '10px',
							color: '#FFFFFF',
							background: evenetColor,
						},
						text: textLabel
					}
				}

				updateAnnotations.xaxis.push(newAnnotation)
				this.options.annotations = updateAnnotations

				this.$refs.chart.updateOptions({ 
					annotations: updateAnnotations
				})
			},

			annotationCharts () {
				let updateAnnotations = this.options.annotations

				if (!this.viewAnnotations)
					return 
				
				const findTemp =  updateAnnotations.xaxis.find( e => {
					return e._id === 'temp'
				})

				if (findTemp !== undefined)
					updateAnnotations.xaxis.pop()

				this.annotation.forEach(element => {
					let colorLabel = '#616161'
					let textLabel = element.text
					let colorBorder = "#FFFFFF"

					element.value = this.devicesDateReport.find( d => d.ts == element.x )

					if(element.isUser)
						colorLabel = '#1E90FF'

					if (element.editable)
						colorBorder = "#000000"

					if (element.isTag) {
						const findTag = this.annotationTag.find( e => {
							return e._id === element.tagId
						})

						if (findTag !== undefined)
							colorLabel = findTag.color
					}

					const newAnnotation = {
						_id: element._id,
						editable: element.editable,
						x: new Date(element.x).getTime(),
						fillColor: colorLabel,
						borderColor: colorLabel,
						label: {
							borderColor: colorBorder,
							style: {
								fontSize: '10px',
								color: '#FFFFFF',
								background: colorLabel,
							},
							text: textLabel
						}
					}
					
					if (Object.hasOwnProperty.call(element, 'x2')) {
						newAnnotation.x2 = new Date(element.x2).getTime()
					}

					updateAnnotations.xaxis.push(newAnnotation)
				})

				this.$refs.chart.updateOptions({ 
					annotations: updateAnnotations
				})
			},

			annotationClean () {
				this.$refs.chart.updateOptions({ 
					annotations: {
						xaxis: []
					}
				})
			},

			dataWindRoseCharts (data) {
				this.dataWindRose = []
				
				for (const key in data) {
					if (data.hasOwnProperty(key)) {
						const element = data[key]

						this.dataWindRose.push({
							theta: ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSO', 'SO', 'OSO', 'O', 'ONO', 'NO', 'NNO'],
							r: element,
							name: key,
							marker: {color: this.colorRoseWind(key)},
							type: "barpolar"
						})
					}
				}
			},
			extremesdataWindRose (type, extremes) {
				
				for (let i = 0; i < extremes.length; i++) {
					const element = extremes[i]

					if (type === 'speed') {
						this.exportData[i]["velocidad max viento"] = +element.max.toFixed(1)
						this.exportData[i]["velocidad min viento"] = +element.min.toFixed(1)

					} else {
						this.exportData[i]["direccion viento"] = element.max
					}
				}
			},

			openDialigoExport () {
				this.exportSelectData = true
			},

			exportExcel() {
				let data = XLSX.utils.json_to_sheet(this.exportData);
				const workbook = XLSX.utils.book_new();
				const filename = `laeq_${this.device.name}_${this.dayReport}`;
				XLSX.utils.book_append_sheet(workbook, data, this.dayReport);
				XLSX.writeFile(workbook, `${filename}.xlsx`);
			},

			async generatePDF() {
				const info = {
					project: this.project,
					device: this.device,
					range: this.selectTimeTreadFix,
					date: this.viewDate,
					isAdmin: this.isAdmin
				}

				try {
					const urlQuery = `date=${this.viewDate}&range=${this.selectTimeTreadFix._id}`
					
					let url = `${this.uriServer}/trend/daily/${this.deviceId}/laeq_001?${urlQuery}`
					const dailyTrend = await axios.get(url, { headers: authHeader() })
					
					if ( dailyTrend.data.data.length === 0 ) {
						this.$store.dispatch('customNotification', {
							text: 'No existen datos para este dia',
							color: 'error'
						})

						return 
					}

					url = `${this.uriServer}/trend/monthly/${this.deviceId}/laeq_001?${urlQuery}`
					const monthlyTrend = await axios.get(url, { headers: authHeader() })

					url = `${this.uriServer}/trend/graph/${this.deviceId}?${urlQuery}`
					const graphs = await axios.get(url, { headers: authHeader() })
					
					const data = {
						annotation: this.annotation,
						dailyTrend: dailyTrend.data.data,
						monthlyTrend: monthlyTrend.data.data,
						graphs: graphs.data.data
					}
	
					reportTrend(this.selectTimeTread, info, data)
				} catch (error) {
					this.$store.dispatch('customNotification', {
						text: 'Error al cargar datos',
						color: 'error'
					})
				}
			},
			
			selectTime (event, chartContext, config) {
				if (config.dataPointIndex < 0)
					return

				if (this.device.privateAudio && !this.isAdmin)
					return

				this.selectChartIndex = config.dataPointIndex
				this.selectChartDate = moment(this.Laeqfs[config.dataPointIndex].x).format()
				this.findAnnotation(this.Laeqfs[config.dataPointIndex].x)

				if (!this.showAnnotations)
					this.showOptionsPanel = true

				if (this.hasAnnotation === -1)
					this.tempSelect(this.Laeqfs[config.dataPointIndex].x)
			},
			tempSelect (x) {
				let updateAnnotations = this.options.annotations

				const findTemp =  updateAnnotations.xaxis.find( e => {
					return e._id === 'temp'
				})
				
				if (findTemp !== undefined)
					updateAnnotations.xaxis.pop()

				let tempAnnotation = {
					_id: 'temp',
					x: new Date(x).getTime(),
					fillColor: '#1E88E5',
					borderColor: '#1E88E5',
					label: {
						borderColor: '#333',
						style: {
							fontSize: '10px',
							color: '#FFFFFF',
							background: '#0070c0',
						},
						text: '●'
					}
				}
        
        this.annotationDates.a = tempAnnotation.x

				if (this.rangeMode) {
					tempAnnotation.x2 = new Date(this.annotaionPoints.a).getTime()
          this.annotationDates.b = tempAnnotation.x2
				}

				updateAnnotations.xaxis.push(tempAnnotation)

				this.$refs.chart.updateOptions({ 
					annotations: updateAnnotations
				})
			},
			clearTempSelect () {
				let updateAnnotations = this.options.annotations
				updateAnnotations.xaxis.pop()
				this.$refs.chart.updateOptions({ 
					annotations: updateAnnotations
				})
			},
			findAnnotation (x) {
				for (let i = 0; i < this.options.annotations.xaxis.length; i++) {
					const element = this.options.annotations.xaxis[i]

					const notTemp = element._id !== 'temp'
					const sameTime = element.x === x || element.x2 === x

					if ( sameTime && notTemp ) {
						this.selectedAnnotation = element
						this.hasAnnotation = i
						return
					}
				}
				
				this.hasAnnotation = -1
			},
			acceptLoadAudio () {
				this.clearTempSelect ()

				if (this.currentFile !== null) {
					const diffTimeAudio = moment(this.selectChartDate).diff(this.currentFile.date, 'seconds')
					
					if (diffTimeAudio <= this.audioDuration && diffTimeAudio > 0) {
						if (this.isPlaying) 
							this.seekAudio(diffTimeAudio)
						else
							this.playAudio (diffTimeAudio)

						return
					}
				}

				this.getAudio (this.selectChartDate, false)
			},
			openAnnotations () {
				this.showAnnotations = true
				this.showOptionsPanel = false
				this.annotaionPoints.a = this.selectChartDate
			},
			addAnnotations () {
				let updateAnnotations = this.options.annotations
				
				const findTemp =  updateAnnotations.xaxis.find( e => {
					return e._id === 'temp'
				})

        const findAudio =  updateAnnotations.xaxis.find( e => {
          return e._id === 'audio'
        })

        if (findAudio !== undefined) {
          this.annotaionPoints.a = moment(findAudio.x).format()
        }

        if (findTemp !== undefined) {
          this.annotaionPoints.a = moment(findTemp.x).format()
          updateAnnotations.xaxis.pop()
        }

        if (findTemp === undefined && findAudio === undefined)
          return

				let textLabel = this.descriptionAnnotation ? this.descriptionAnnotation : this.selectTag.text
				let colorLabel = this.isCustomLabel ? '#1E90FF' : this.selectTag.color


				let payload = {
					deviceId: this.deviceId,
					isTag: !this.isCustomLabel,
					text: textLabel,
					x: this.annotaionPoints.a,
					deviceId: this.deviceId,
					dayReport: this.dayReport,
				}

				if (this.rangeMode)
					payload.x2 = this.annotaionPoints.b

				if (!this.isCustomLabel)
					payload.tagId = this.selectTag._id

				this.$store.dispatch('pushAnnotation', payload)
        .then((response) => {
          let newAnnotation = {
						_id: response.data._id,
						editable: true,
						x: new Date(this.annotaionPoints.a).getTime(),
						fillColor: colorLabel,
						borderColor: colorLabel,
						label: {
							borderColor: '#000000',
							style: {
								fontSize: '10px',
								color: '#FFFFFF',
								background: colorLabel,
							},
							text: textLabel
						}
					}

					if (this.rangeMode) {
						newAnnotation.x2 = new Date(this.annotaionPoints.b).getTime()
					}

					updateAnnotations.xaxis.push(newAnnotation)

					this.$refs.chart.updateOptions({ 
						annotations: updateAnnotations
					})
                })
				.finally( () => {
					this.showAnnotations = false
					this.showOptionsPanel = true
					this.annotationTypeMode = 'point'
					this.annotationMode = 'custom'
				})
			},
			cancelAnnotations () {
				this.annotaionPoints = {
					a: null,
					b: null
				}

				this.annotationTypeMode = 'point'
				this.annotationMode = 'custom'
				this.showAnnotations = false
				this.showOptionsPanel = true
				this.selectTag = null
				this.descriptionAnnotation = null
			},
			removeAnnotations () {
				let updateAnnotations = this.options.annotations
				let payload = {
					id: updateAnnotations.xaxis[this.hasAnnotation]._id,
				}

				this.$store.dispatch('removeAnnotation', payload)

				updateAnnotations.xaxis.splice(this.hasAnnotation, 1)

				this.$refs.chart.updateOptions({ 
					annotations: updateAnnotations
				})
				
			},
			getAudio (date, isEnd) {
				this.loadAudio = true
				
				if (this.sound !== null)
					this.stopAudio ()

				const url = `${this.uriServer}/audio/${this.deviceId}?date=${date}&end=${isEnd}`

				axios
				.get(url, { headers: authHeader() })
				.then(response => {
					this.startAudio(response.data)
				})
				.catch(error => {
					this.loadAudio = false
					this.$store.dispatch('errorNotification', { msg: 'No se pueden cargar datos de audio', error: error })
					console.log(error)
				})
				.finally(() => {})
			},
			startAudio (inputSound) {
				this.currentFile = inputSound

				const sound = new Howl({
					id: 1212,
					src: [inputSound.url],
					html5: true,
					volume: 1
				})

				sound.once('load', () => {
					this.audioDuration = sound.duration()
					const theoffset = new Date(inputSound.date).getTime() + inputSound.offset
					this.loadAudio = false
					this.audioController.offset = inputSound.offset
					this.audioController.dateOffset = new Date(inputSound.date).getTime() + inputSound.offset

					this.playAudio()
				})

				sound.on('end', () => {
					const nextAudio = moment(inputSound.date).add(this.audioDuration + 30, 'seconds').format()
					this.getAudio(nextAudio, true)
				})

				this.sound = sound
			},
			playAudio (offset, timeOffset) {
				this.seekAudio(this.audioController.offset)
				this.sound.play()
				clearInterval(this.interval)
				this.interval = 0
				this.isPlaying = true
				this.isPlay = true
				let newOffset = this.audioController.dateOffset
				
				this.interval = setInterval(() => {
					const updateAnnotations = this.options.annotations
					
					const findAudio =  updateAnnotations.xaxis.find( e => {
						return e._id === 'audio'
					})
				
					if (findAudio !== undefined)
						updateAnnotations.xaxis.pop()

					const seek = this.sound.seek()
					const unixTime = seek*1000 + newOffset
					const textSecond = moment(unixTime)

					updateAnnotations.xaxis.push({
						_id: 'audio',
						x: unixTime,
						borderColor: '#00E396',
						label: {
							borderColor: '#00E396',
							orientation: 'horizontal',
							text: textSecond.format("HH:mm:ss") + ` [${this.Laeqfs[this.selectChartIndex].y.toFixed(2)} dBA]`
						}
					})
				  
          this.annotationDates.a = textSecond.format()

					const indexTime = moment(this.Laeqfs[this.selectChartIndex].str).add(1, 'minute')
                    
					if (indexTime.isSame(textSecond.format()))
						this.selectChartIndex++

					this.audioController.dateOffset++
					this.audioController.offset++

					this.$refs.chart.updateOptions({ 
						annotations: updateAnnotations
					})
				}, 1000)
                    
			},
			stopAudio () {
				clearInterval(this.interval)
				this.interval = 0
				this.sound.stop()
				this.isPlaying = false
			},
			pauseAudio () {
				clearInterval(this.interval)
				this.isPlay = false
				this.interval = 0
				this.sound.pause()
			},
			seekAudio (seconds) {
				this.sound.seek(seconds)
			},
			getUrl (file) {
				const payload = {
					key: file
				}

				this.$store.dispatch('getDownloadUrl', payload)
			},
			formatTime (seek) {
				let second = Math.round(seek)
				let minutes = Math.floor(second / 60) || 0;
				let seconds = (second - minutes * 60) || 0;
				return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
			},
			colorRoseWind (speed) {
				let chartRose = {
					'0-2 [m/s]': '#9e9e9e',
					'2-5 [m/s]': '#0e37fb',
					'5-7 [m/s]': '#26d5fd',
					'7-10 [m/s]': '#83fc83',
					'10-15 [m/s]': '#ffe435',
					'15-20 [m/s]': '#fb4821',
					'> 20 [m/s]': '#7e0209'
				}
				
				return chartRose[speed]
			},
			offsetOperation (operation) {
				switch (operation) {
					case ('collation'):
						return 2
					case ('line'):
						return 8
					case ('planter'):
						return 6
					case ('staker'):
						return 4
					case ('rustic'):
						return 10
					case ('detention'):
						return 12
				}
			},
			nameOperation (operation) {
				switch (operation) {
					case ('collation'):
						return 'Colación'
					case ('line'):
						return 'Línea'
					case ('planter'):
						return 'Cepilladora p.c.'
					case ('staker'):
						return 'Staker'
					case ('rustic'):
						return 'Rústico'
					case ('detention'):
						return 'Deteción'
				}
			},
			colorOperation (operation) {
				switch (operation) {
					case ('collation'):
						return '#FF9F90'
					case ('line'):
						return '#ffc000'
					case ('planter'):
						return '#0070c0'
					case ('staker'):
						return '#cc00cc'
					case ('rustic'):
						return '#ffff00'
					case ('detention'):
						return '#ffe598'
				}
			},

			laeqOffset (deviceId, sensorName) {
				const findSensor = this.allSensors.filter( sensor => sensor.deviceId === deviceId && sensor.sensorName === sensorName )

				if (findSensor.length > 0)
					return findSensor[0].offset

				return 0
			},

			sortRange (date) {
                if (date.length == 1)
                    return { from: date[0] }

                if (date.length == 2) {
                    const compareDates = (date1, date2) => {
                        if (date1 < date2)
                            return -1
                        else if (date1 > date2)
                            return 1
                        else
                            return 0
                    }

                    date.sort(compareDates)

                    return { from: date[0], to: date[1] }
                }

                return null
            },
		},

		computed: {
			isCustomLabel () {
				return !this.isAdmin
			},

			rangeMode () {
				return this.annotationTypeMode == 'range'
			},

			allSensors () {
				return this.$store.getters.allSensors
			},

			isLoading () {
				return this.$store.getters.isLoading
			},

			uriServer () {
				return this.$store.getters.uri
			},

			loadingReportData () {
				return this.$store.getters.loadingReportData
			},

			deviceId () {
				return this.$route.params.id
			},

			viewDate () {
				return this.$store.getters.viewDate
			},

			dayReport () {
				let parcheDate = +(this.devicesDateReport.length / 2).toFixed()
				return moment(this.devicesDateReport[parcheDate].ts).format("YYYY-MM-DD") 
			},

			viewRecord () {
                return this.$store.getters.record
			},
			
			devicesDateReport () {
                return this.$store.getters.devicesDateReport
			},

			dateReport () {
				if (this.devicesDateReport !== null)
					return this.devicesDateReport.date
				else
					return null
			},

			devicesDateWindRose () {
                return this.$store.getters.windRose
			},

			devicesDateClassificationEvents () {
                return this.$store.getters.classificationEvents
			},

			showChartClassificationEvents () {
				return this.serieClassificationEvents.length > 0
			},

			dateOperation () {
                return this.$store.getters.operation
			},
			
			device () {
				return this.$store.getters.device(this.$route.params.id)
			},

			deviceSensor () {
				return this.device.sensors
			},
			showWindRose () {
				const hasSpeed = this.deviceSensor.some(s => s.sensorType === 'windSpeed')
				const hasDirection = this.deviceSensor.some(s => s.sensorType === 'windDirection')

				return hasSpeed && hasDirection && this.hasWindRose
			},
			laeqFilter () {
				if (!Object.hasOwnProperty.call(this.device, "laeqFilter")) {
                    return {
                        max: 100,
                        min: 0
                    }
                }

				return this.device.laeqFilter
			},

			downloadUrl () {
				return this.$store.getters.downloadUrl
			},
			labelAnnotationMode () {
				return !this.isCustomLabel ? 'Etiqueta' : 'Personalizado'
			},
			labelRangeMode () {
				return !this.rangeMode ? 'Punto' : 'Rango'
			},
			hasRange () {
				return this.annotaionPoints.b !== null
			},
			annotationTag () {
                return this.$store.getters.annotationTag
            },
			annotation () {
                return this.$store.getters.annotation
            },
			user () {
                return this.$store.getters.user
            },
            isAdmin () {
                return this.user.roles.some( e => {
                    return e.name === 'admin'
                })
            },
			deviceEvent () {
				return this.$store.getters.devicesDateEvent
			},

			reportReferences () {
				return this.$store.getters.reportReferences(this.deviceId)
			},

			reportReferencesChart () {
				if (this.reportReferences === undefined)
					return []

				return this.reportReferences.map ( e => {
					return {
						x: moment(`${this.dayReport}  ${e.time}`).format(),
						y: e.value
					}
				})
			},

			externalEvents () {
				return this.deviceEvent.filter( e => {
					return e.event.indexOf('E-') !== -1
				})
			},

			internalEvents () {
				return this.deviceEvent.filter( e => {
					return e.event.indexOf('I-') !== -1
				})
			},

			rangeReportData () {
				return this.$store.getters.rangeReportData
			},

			project () {
				const selectProject = this.device.projectId
				const projects = this.$store.getters.projects
				const infoProject = projects.find( e => e.projectId === selectProject )
				
				const nameProject = infoProject ? infoProject.name : 'Sin Asignar'
				return nameProject
			},

			rangeTrend () {
				return this.$store.getters.rangeTrend
			},

			isRangeDate () {
				return this.rangeReportData != undefined
			},

			annotationEditable () {
				return 'editable' in this.selectedAnnotation ? this.selectedAnnotation.editable : false
			},

			selectTimeTreadFix () {
				return this.rangeTrend.find( e => e.description == this.selectTimeTread)
			},
			
			rengeTimeDetails () {
				if (this.selectTimeTreadFix)
					return `Desde las ${this.selectTimeTreadFix.start} hasta las ${this.selectTimeTreadFix.end}`
			}
		},

		watch: {
			devicesDateReport (val) {
				if ( val == null ) {
					this.$store.dispatch('customNotification', {
						text: 'No existen datos para este dia',
						color: 'error'
					})
					return
				}

				if ( val.length == 0 ) {
					this.$store.dispatch('customNotification', {
						text: 'No existen datos para este dia',
						color: 'error'
					})
					return
				}

				this.exportData = []
				this.colorSeries = []
				this.settings = []
				this.exportDataReady = false

				this.viewExtremes = false
				this.dataCharts(val)
				this.extremesCharts(val)

				if (this.viewExtremes)
					this.loadExtrenesChart()

				this.exportDataReady = true

				let payload = {
					date: this.dayReport,
					deviceId: this.deviceId,
					sensor: 'laeq_001'
				}

				if (Array.isArray(this.viewDate)) {
                    const range = this.sortRange(this.viewDate)
                    payload.date = range.from
                    payload.endDate = range.to
                }

                this.$store.dispatch('pullAnnotation', payload)
				this.$store.dispatch('pullDeviceDateEvents', payload)
			},

			deviceEvent (val) {
				if (val == null || val.length === 0)
					return

				this.loadEventsChart()
			},

			dateReport (val) {
				if (this.sound !== null)
					this.stopAudio ()
			},

			devicesDateWindRose (val) {
				const hasData = val.hasOwnProperty('message') || val.length === 0

				if (val === null || hasData) {
					this.hasWindRose = false
					return
				}

				this.hasWindRose = true
				this.dataWindRoseCharts(val)
			},

			devicesDateClassificationEvents (val) {
				let label = []
				let serie = []

				for (let key in val) {
					label.push(key)
					serie.push(val[key])
				}
				
				this.serieClassificationEvents = serie

				this.$refs.chartEvent.updateOptions({ 
					labels: label,
				})
			},

			
			downloadUrl (val) {
				window.open(val, '_blank')
			},

			selectChartDate (val) {
				if (this.showAnnotations && this.rangeMode) {
					this.annotaionPoints.b = val
				}
			},

			annotation (val) {
				if (val == null || val.length === 0)
					return

				this.annotationCharts(val)
			},

			annotationTag ( val ) {
				if ( val.length > 0) {
					const defaultTag = val.find ( e => e.text == 'Nota')

					if (defaultTag)
						this.selectTag = defaultTag
				}
			},
			
			viewAnnotations (val) {
				if (val)
					this.annotationCharts()
				else
					this.annotationClean()
			},

			viewExtremes (val) {
				if (this.extremesElements.length === 0 && val)
					this.loadExtrenesChart()

				this.extremesElements.forEach ( e => {
					this.$refs.chart.toggleSeries(e)
				})
			},

			colorSeries (val) {
				if (val.length === 0)
					return 
					
				let newColor = []
				for (let i = 0; i < this.series.length; i++) {
					const seriesName = this.series[i].name
					for (let j = 0; j < val.length; j++) {
						const element = val[j]
						if (element.name === seriesName) {
							newColor[i] = element.color
							break
						}
					}
				}

				this.options = {...this.options, ...{
					colors: newColor
				}}
			},

			settings (val) {
				this.viewAnnotations = val.some( e => {return e == 0})
				this.viewExtremes = val.some( e => {return e == 1})
				this.viewEvents = val.some( e => {return e == 2})
			},

			reportReferencesChart ( ) {
				this.loadReferenceChart()
			},

			rangeTrend (val) {
				if ( val.length > 0 ) 
					this.selectTimeTread = val[0].description
			}
		},

		filters : {
		  dateFormat (val) {
        if ( Array.isArray(val) ) {
          if (!moment(val[0]).isValid())
            return val

          if (!moment(val[1]).isValid())
            return val

          return `Desde ${moment(val[0]).format('LTS')} a ${moment(val[1]).format('LTS')}`
        } else {
          if (!moment(val).isValid())
            return val
  
          return moment(val).format('LTS')
        }
      },
		},

		components: {
			apexchart: VueApexCharts,
			Plotly
		},

		created () {
			moment.locale('es-us')
			this.$store.dispatch('pullAnnotationTag')
			this.$store.dispatch('pullRangeTrend')
		},

		beforeDestroy () {
			if (this.sound !== null)
				this.stopAudio ()
		}
	}
</script>